import { BaseAPI } from './BaseAPI.js'
import { CampaignListRecord } from '../types/index.js'

export default class CampaignListRecordsAPI extends BaseAPI<CampaignListRecord> {
  override get resource(): string {
    return '/campaignListRecords'
  }
}
